const reprovedProcess = (processStats) => {
  return processStats?.departments?.reduce(
    (value, department) => value + department.statuses?.approved,
    0,
  )
}

export default reprovedProcess
